import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { CloudwatchService } from '../../service';

export type AlarmActionsConfiguredConfig = typeof AlarmActionsConfiguredConfig._.Config;

export const AlarmActionsConfiguredConfig = IntegrationConfig.make({
  service: CloudwatchService,
  name: Integration_Handler_Names_Enum.AlarmActionsConfigured,
  configSchema: z.object({
    insufficientDataActionRequired: z.boolean().optional(),
    okActionRequired: z.boolean().optional(),
  }),
});
